export default __webpack_public_path__ + "static/media/squares1300.62daa0fb.jpg";